import {axiosInstance} from "../utils/axios";

export const startMeeting = ({classId}) => {
    if (!classId)
        return

    return axiosInstance.post(`${classId}/startUrl`);
}

export const joinMeeting = ({classId, payload}) => {
    if (!classId || !payload)
        return

    return axiosInstance.post(`${classId}/joinUrl`, payload);
}